export const MEMO_PURPOSE_FILED_LENGTH_LIMIT = 4095;
export const SIGNER_ROLE_NAME_FIELD_LENGTH_LIMIT = 128;
